import { StepId } from '../../api/useRiskToleranceWorkflowQuery';

export interface FormValues {
  [StepId.DownMarket]: number;
}

export const title =
  'How long are you prepared to wait for your account to return to its original value after a down market?';

export const options = [
  { label: '<18 Months', value: 1 },
  { label: '18 Months - 2 Years', value: 2 },
  { label: '2-3 Years', value: 3 },
  { label: '3-5 Years', value: 4 },
  { label: '>5 Years', value: 5 },
];
